/*
 * Module for categoryList
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./categoryListView",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Backbone, Messenger, CategoryListView, SelectableListModule) {
  var CategoryController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categories";
      this.namespace = options.namespace;
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.layout = new CategoryListView.categoryListLayout();

      this.list = this.addSubModule(
        new SelectableListModule({
          region: this.layout.list,
          nameAttribute: "categoryName",
          namespace: this.namespace,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this.list.show(this.categories);
        },
        this,
      );

      this._setupView();
    },
    focus: function () {
      if (this.isOpen && this.list) {
        this.list.focus();
      }
    },

    _setupView: function () {
      this.categories = Messenger.reqres.request("kb:categories");
      this.showRegion(this.layout, { entity: this.categories, loading: true });
    },

    /*
     * Selects the variable in the list with the provided variable Id
     */
    setSelected: function (id) {
      console.log("setSelected for id: " + id);
      this.categories.onSynced(function () {
        var category = this.categories.get(id);
        if (category) {
          this.list.selectItem(category);
        }
      }, this);
    },

    _setUpVents: function () {
      Messenger.vent.on(
        Messenger.getFullName("list:item:selected", this.namespace),
        function (category) {
          Messenger.vent.trigger(
            Messenger.getFullName("show:categoryInfo", this.namespace),
            category,
          );
        },
        this,
      );
    },
  });

  return CategoryController;
});
